import { ddRum, rumErrorCtx, SEVERITY } from '@web-platform/browser-rum';
import { throwError, from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { getDefaultErrorContext } from 'common/utils/rum-utils';

const fetchObservableUtil = (url, options, { rethrow = false } = {}) =>
  from(fetch(url, options)).pipe(
    switchMap(res => {
      if (!res.ok) {
        return throwError(res);
      }
      if (res.status === 204) {
        return of({}); // Safe return for observable, need to figure out something better
      }
      return res.json ? res.json() : res;
    }),
    catchError(err => {
      // eslint-disable-next-line no-console
      console.log(err);

      const errorCtx = rumErrorCtx(getDefaultErrorContext())
        .component('fetchObservableUtil')
        .severity(SEVERITY.MEDIUM)
        .message(`HTTP request failed`)
        .custom('url', url)
        .custom('rethrow', rethrow)
        .build();
      ddRum.addError(err, errorCtx);

      if (rethrow) {
        throw err;
      }
    }),
  );

export const catchAndReturnError = catchError(error => of({ error }));

export default fetchObservableUtil;
